import React from "react";

import CampaignsIcon from "../icons/CampaignsIcon";
import EngagedIcon from "../icons/EngagedIcon";
import RateIcon from "../icons/RateIcon";
import SentIcon from "../icons/SentIcon";

export type OverviewIconProps = {
  width?: number;
  height?: number;
  fill?: string;
};

export const iconMapping = (
  key: string,
  props?: OverviewIconProps,
) => {
  const defaultProps = { width: 45, height: 45, ...props };

  switch (key) {
    case "campaigns":
      return React.createElement(CampaignsIcon, defaultProps);
    case "sent":
      return React.createElement(SentIcon, defaultProps);
    case "engaged":
      return React.createElement(EngagedIcon, defaultProps);
    case "rate":
      return React.createElement(RateIcon, defaultProps);
    default:
      return null;
  }
};

export default { iconMapping };
